// PROGRAMS CORE - Bootstrap & Event Bus
// The PROGRAMS architecture: each major element is a self-contained PROGRAM
// Programs register themselves and communicate via events

(function() {
    'use strict';

    window.PROGRAMS = window.PROGRAMS || {};

    var core = {
        _programs: {},
        _handlers: {},
        _initialized: false,

        // Register a PROGRAM module
        register: function(name, program) {
            this._programs[name] = program;
            // Alias on PROGRAMS namespace: PROGRAMS.Cart, PROGRAMS.Product, etc.
            window.PROGRAMS[name] = program;
            console.log('[PROGRAMS] Registered:', name);
        },

        // Initialize all registered programs
        init: function() {
            if (this._initialized) return;
            this._initialized = true;

            var names = Object.keys(this._programs);
            console.log('[PROGRAMS] Initializing', names.length, 'programs:', names.join(', '));

            for (var i = 0; i < names.length; i++) {
                var name = names[i];
                var program = this._programs[name];
                if (typeof program.init === 'function') {
                    try {
                        program.init();
                        console.log('[PROGRAMS]', name, 'initialized');
                    } catch (e) {
                        console.error('[PROGRAMS]', name, 'init error:', e);
                    }
                }
            }
        },

        // Event bus - emit event to all listeners
        emit: function(event, data) {
            var handlers = this._handlers[event];
            if (!handlers) return;
            for (var i = 0; i < handlers.length; i++) {
                try {
                    handlers[i](data);
                } catch (e) {
                    console.error('[PROGRAMS] Event handler error for', event, ':', e);
                }
            }
        },

        // Event bus - subscribe to event
        on: function(event, handler) {
            if (!this._handlers[event]) {
                this._handlers[event] = [];
            }
            this._handlers[event].push(handler);
        }
    };

    // Merge core methods onto PROGRAMS (preserving any data already set by Liquid)
    Object.keys(core).forEach(function(key) {
        window.PROGRAMS[key] = core[key];
    });

    // Auto-init on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
        window.PROGRAMS.init();
    });
})();
